import API from './api';
// import LocalStorageService from './localStorage';

// const localStorageService = LocalStorageService.getService();


export const getTenantList = () => {
  return API.get(`pacheck-portal/orgs/list`);
};

